import React, { useEffect, useState } from 'react';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Font,
    Image,
    PDFViewer
} from '@react-pdf/renderer';
import { format } from '../../App'
import moment from 'moment';
import QRCode from 'qrcode'

import { cover, notpaid, paid, scanpaid, logo, checked, qrpay, carcover } from '../../data/pic'
import phetsarath from '../font/PHETSARATH OT.TTF'
// import D from './MakeDocLongFirst'


// let logo = './images/full.png'
// let checked = './images/checked.png'
// let qrpay = './images/qrpay.jpg'
// let carcover = './images/carcover.jpg'

const QR = process.env.REACT_APP_QR
Font.register({
    family: 'PHETSARATH OT', fonts: [
        { src: phetsarath },
    ],
});

const styles = StyleSheet.create({
    page: {
        fontFamily: "PHETSARATH OT",
        paddingTop: 12,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 10

    },
    chinafont: {
        fontFamily: "PHETSARATH OT",
    },
    row: {
        flexDirection: 'row',
        marginBottom: 2,
        marginRight: 5,
        marginLeft: 5,
        padding: 5,
        borderWidth: 0.5,
    },
    row_p: {
        flexDirection: 'row',
        marginBottom: 0,
        marginRight: 5,
        marginLeft: 5,
        padding: 2,

    },
    row_table: {
        flexDirection: 'row',
        width: '100%',
        padding: 5,
        borderBottomWidth: 0.3,
        display: 'flex'
    },
    row_wrap: {
        flexDirection: 'row',
        marginBottom: 2,
        marginRight: 5,
        marginLeft: 5,
        flexWrap: 'wrap'
    },
    rowC: {
        flexDirection: "column",
        marginBottom: 2,
        marginRight: 5,
        marginLeft: 5,
        padding: 5,
        borderWidth: 0.5,
    },
    rowR: {
        flexDirection: "row",
        marginBottom: 2,
        marginRight: 5,
        marginLeft: 5,
        padding: 5,
        borderWidth: 0.5,
    },

    box: {
        display: 'flex',
        flexDirection: 'row',
    },
    box_o: {
        flex: 1,
        paddingRight: 5,
    },
    box_o1: {
        flex: 1,
    },
    box_o2: {
        flex: 3,
    },
    box_c: {
        flexGrow: 0,
        backgroundColor: '#fff'
    },
    box_f: {
        backgroundColor: '#fff',
        width: '100%'
    },
    fontHead: {
        fontSize: 9
    },
    fontHeadSmall: {
        fontSize: 6,
        paddingLeft: 40
    },

    fontNalmal: {
        fontSize: 14
    },
    logo1: {
        width: 90,
        padding: 0
    },
    ico: {
        width: 15,
        height: 15,
        paddingRight: 3

    },

    col: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    col_1: {
        flex: 2,
        alignItems: 'center',
        justifyContent: 'center'
    },
    _col: {
        flex: 2,
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingRight: 5
    },
    col1: {
        flex: 4,
        paddingLeft: 5
    },
    col2: {
        flex: 2,
        alignItems: 'flex-end',
        paddingRight: 5
    },
    col3: {
        flex: 1,
        alignItems: 'flex-end',
        paddingRight: 5
    },
    col4: {
        flex: 2,
        alignItems: 'flex-end', paddingRight: 5
    },
    info: {
        position: 'absolute',
        left: 55,
        bottom: 10,
        fontSize: 9
    },
    qr: {
        width: 50,
        height: 50,
        position: 'absolute',
        left: 5,
        bottom: 10,
    },
    qrCar: {
        width: 50,
        height: 50,
        // position: 'absolute',
        // left: 5,
        // bottom: 10,
    },


    image: {
        position: 'absolute',
        minWidth: '100%',
        minHeight: '100%',
        display: 'block',
        height: '100%',
        width: '100%',
    },
});




const generateQR = async (text) => {
    return QRCode.toDataURL(text)
        .then(url => {
            return (url)
        })
        .catch(err => {
            return (err)
        })
}

export function pad(num) {
    if (num) {
        num = num.toString();
        while (num.length < 6) num = "0" + num;
        return num;
    } else {
        return 0
    }
}

const MakeDocLong = (props) => {
    let { no, user, oneData, thirdcover_option, drivercover_option, } = props
    const [imgsvg, setimgsvg] = useState(generateQR(`${QR + no}`))
    useEffect(async () => {
        setimgsvg(await generateQR(`${QR + no}`))
    }, [no])
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ width: '100%', backgroundColor: '#3B9A9C', display: 'flex' }}>
                <PDFViewer
                    showToolbar
                    style={{ width: '100%', height: 1000 }}
                >
                    <D
                        user={user}
                        img={imgsvg}
                        no={oneData}
                        thirdcover_option={thirdcover_option}
                        drivercover_option={drivercover_option}
                    />
                </PDFViewer >
            </div>
        </div>
    )
}

export default MakeDocLong

const D = (props) => {
    let {
        img,
        no,
        user,
        thirdcover_option,
        drivercover_option
    } = props
    // console.log(thirdcover_option)
    // console.log(drivercover_option)
    function thridcover() {
        return thirdcover_option.map((v, i) => {
            try {
                let cover = no.cover
                let textCover = cover.split("-")
                if (v.car_op_name === textCover[0]) {
                    return (
                        <View key={i} style={{ ...styles.row_table }}>
                            <View style={styles.col} >
                                <Text style={styles.fontHead}>
                                    {v.car_op_name}
                                </Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>
                                    {format(v.bodily)} kip
                                </Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.death)} kip</Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.medical)} kip</Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.hostpital)} kip</Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.material)} kip</Text>
                            </View>

                        </View>
                    )
                } else if (v.car_op_name === '00') {
                    return (
                        <View key={i} style={{ ...styles.row_table }}>
                            <View style={styles.col} >
                                <Text style={styles.fontHead}>
                                    No false
                                </Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>
                                    {format(v.bodily)} kip
                                </Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.death)} kip</Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.medical)} kip</Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.hostpital)} kip</Text>
                            </View>
                            <View style={styles._col} >
                                <Text style={styles.fontHead}>{format(v.material)} kip</Text>
                            </View>

                        </View>
                    )
                }




            } catch (error) {

            }
        })

    }

    return (
        <Document>
            <Page
                size="A4"
                style={styles.page}
            >
                <View style={styles.row}>
                    <View style={styles.box_o} >
                        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }}>
                            <Text style={{ fontSize: 12, color: 'red', paddingRight: 10 }}>
                                E-NO: {no.policy_type === 'MS' ? 'MS-' : null}{no.cancel === 1 ? `${pad(no.no)} ຖືກຍົກເລີກ` : pad(no.no)}
                            </Text>
                            <View style={{ display: 'flex', alignItems: 'center', paddingRight: 10 }}>
                                <Text style={styles.fontHead}>ໃບຢັ້ງຢືນປະກັນໄພຍານພາຫະນະ</Text>
                                <Text style={{ fontSize: 7 }}>MOTOR VEHICLE INSURANCE SCEDULE</Text>
                            </View>
                            <Image src={logo} style={styles.logo1} />

                        </View>
                        <Text style={styles.fontHead}>ຊື່ ແລະ ນາມສະກຸນ/Name {'&'} Surname: {no.o_name}</Text>
                        <Text style={styles.fontHead}>ທີ່ຢູ່/ Address: {no.o_address}</Text>
                        <Text style={styles.fontHead}>ໂທລະສັບ/ Phone:{no.o_tel} ; ປະເພດລົດ/ Vehicle type:{no.o_type}</Text>
                        <Text style={styles.fontHead}>ຫຍີ່ຫໍ້/ Make:{no.o_make} ; ເລກທະບຽນ/Plate No:{no.o_plate}</Text>
                        <Text style={styles.fontHead}>ສີລົດ/ Color:{no.o_color} ; ຄວາມແຮງ/ Power CC:{no.o_power}</Text>
                        <Text style={styles.fontHead}>ເລກຈັກ/Engine No:{no.o_engine}; ເລກຖັງ/ Chassis No:{no.o_chassis}</Text>
                        <Text style={styles.fontHead}>ນ້ຳໜັກ/ Wheight:  {no.o_weight}  ໂຕນ/Ton;  ຈຳນວນບ່ອນນັ່ງ/ Seats: {no.o_seats}</Text>

                    </View>

                    <View style={{ paddingLeft: 0, borderWidth: 0.5, borderRadius: 7, padding: 7 }}>
                        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }}>
                            <Image src={logo} style={{ width: 70, }} />
                            <View style={{ display: 'flex', alignItems: 'center', paddingRight: 0 }}>
                                <Text style={{ fontSize: 8 }}>ໃບຢັ້ງຢືນປະກັນໄພຍານພາຫະນະ</Text>
                                <Text style={{ fontSize: 5 }}>MOTOR VEHICLE INSURANCE SCEDULE</Text>
                                <Text style={{ fontSize: 10, color: 'red', paddingRight: 5 }}>E-NO: {no.policy_type === 'MS' ? 'MS-' : null}{no.cancel === 1 ? `${pad(no.no)} ຖືກຍົກເລີກ` : pad(no.no)}
                                </Text>
                            </View>
                        </View>

                        <Text style={styles.fontHead}>*ໄລຍະການຄຸ້ມກັນ/ Period of Cover</Text>
                        <Text style={styles.fontHead}> {"   "}-ເລີ່ມແຕ່/ From: {moment(no.start).format("DD/MM/YYYY HH:mm:ss")}</Text>
                        <Text style={styles.fontHead}> {"   "}-ເຖິງ/ To: {moment(no.end).format("DD/MM/YYYY HH:mm:ss")}</Text>
                        <Text style={styles.fontHead}>*ເລກທະບຽນລົດ/ Plate: {no.o_plate}</Text>
                        <Text style={styles.fontHead}>*ການຄຸ້ມກັນ/ Cover: {no.cover}</Text>
                        <Text style={styles.fontHead}>Claim Hotline 24Hr: 020 5799 9922-33</Text>
                    </View>
                </View>

                {
                    no.policy_type != 'MS' && <View style={styles.rowR}>
                        <View style={styles.box_o2} >
                            <View style={styles.box_f}>
                                <Text style={styles.fontHead}>ພາກທີ່1:ການປະກັນໄພລົດທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ/ Part 1: Motor Vehicle Third Party Liability Insurance.</Text>
                                <View style={{
                                    flexDirection: 'row',
                                    marginBottom: 2,
                                    marginRight: 5,
                                    marginLeft: 5,
                                    flexWrap: 'wrap'
                                }}>
                                    {
                                        no.a_used === "private" ?
                                            <>
                                                <Image src={checked} style={styles.ico} />
                                                <Text style={styles.fontHead}> ລົດສ່ວນໂຕ/ Private </Text>
                                            </> :
                                            <>
                                                <Image src={checked} style={styles.ico} />
                                                <Text style={styles.fontHead}> ຮັບຈ້າງ/ Business </Text>
                                            </>
                                    }

                                    {
                                        no.a_type === "new" ?
                                            <>
                                                <Image src={checked} style={styles.ico} />
                                                <Text style={styles.fontHead}> ສັນຍາໃໝ່/ New</Text>
                                            </>
                                            :
                                            <>
                                                <Image src={checked} style={styles.ico} />
                                                <Text style={styles.fontHead}>ຕໍ່ສັນຍາ/ Renewal </Text>
                                            </>
                                    }

                                </View>
                            </View>
                            <View style={styles.box_f}>
                                <Text style={styles.fontHead}>ພາກທີ2: ການປະກັນໄພໂຕລົດ/Part 2: Information for Own Damage Cover</Text>
                                <View style={styles.row_wrap}>
                                    <Text style={styles.fontHead}>ວົງເງິນຄຸ້ມກັນ/ Sum Insurance:{no.c_insured}; </Text>
                                    {
                                        no.c_curren === "USD" && <Text style={styles.fontHead}> USD </Text>
                                    }
                                    {
                                        no.c_curren === "THB" && <Text style={styles.fontHead}> THB </Text>
                                    }
                                    {
                                        no.c_curren === "LAK" && <Text style={styles.fontHead}> LAK </Text>
                                    }
                                </View>
                            </View>
                            <View style={styles.box_f}>
                                <Text style={styles.fontHead}>ໝາຍເຫດ:</Text>
                                <View style={{
                                    flexDirection: 'row',
                                    marginBottom: 5,
                                    marginRight: 5,
                                    marginLeft: 5,
                                    padding: 5,
                                }}>
                                    {
                                        no.c_tex === 1 ?
                                            <>
                                                <Image src={checked} style={styles.ico} />
                                                <Text style={styles.fontHead}> ເສຍພາສີ/ Tax </Text>
                                            </>
                                            :
                                            <>
                                                <Image src={checked} style={styles.ico} />
                                                <Text style={styles.fontHead}> ບໍ່ເສຍພາສີ/ No tax </Text>
                                            </>
                                    }
                                </View>
                            </View>
                        </View>
                        <View style={styles.box_o1} >
                            <View style={styles.col}>
                                <Image src={carcover} style={styles.qrCar} />
                                <Text style={styles.fontHead}>
                                    ລາຍລະອຽດການຄຸ້ມກັນ
                                </Text>
                                <Image src={cover}
                                    style={{ width: 45 }}
                                />
                            </View>
                        </View>
                    </View>

                }

                {/* ຮັບຜິດຊອບທາງແຜ່ງຕໍ່ບຸກຄົນທີ ສາມ/ Third party liability Cover A/ */}
                <View style={{
                    flexDirection: "column",
                    marginBottom: 2,
                    marginRight: 5,
                    marginLeft: 5,
                    padding: 5,
                    borderWidth: 0.5,
                }}>

                    <View style={styles.box_f}>
                        <Text style={styles.fontHead}>ຮັບຜິດຊອບທາງແຜ່ງຕໍ່ບຸກຄົນທີ ສາມ/ Third party liability Cover A/B</Text>

                        <View style={{ ...styles.row_table }}>
                            <View style={styles.col} >
                                <Text style={styles.fontHead}>ທາງເລືອກ/ Option </Text>
                            </View>
                            <View style={styles.col_1} >
                                <Text style={styles.fontHead}>ຄວາມເສຍຫາຍທາງ ດ້ານຮ່າງກາຍທັງໝົ້ດ </Text>
                                <Text style={styles.fontHead}> Bodily injury, max per accident </Text>
                            </View>
                            <View style={styles.col_1} >
                                <Text style={styles.fontHead}>ເສຍຊີວິດ ຫຼື ພິການຖາວອນ </Text>
                                <Text style={styles.fontHead}> Death Max or Total </Text>
                                <Text style={styles.fontHead}>  Permanent Disability </Text>
                            </View>
                            <View style={styles.col_1} >
                                <Text style={styles.fontHead}>ຄ່າປິ່ນປົວສູງສຸດ/ ຄົນ </Text>
                                <Text style={styles.fontHead}> Medica expenses, Max per person  </Text>
                            </View>
                            <View style={styles.col_1} >
                                <Text style={styles.fontHead}>ໃນນັ້ນລວມທັງ ຄ່ານອນໂຮງໝໍ</Text>
                                <Text style={styles.fontHead}> Of which Hospitalization allowance</Text>

                            </View>
                            <View style={styles.col_1} >
                                <Text style={styles.fontHead}>ຄວາມເສຍຫາຍ ທາງດ້ານວັດຖຸ </Text>
                                <Text style={styles.fontHead}> Material Damages, Max per accident </Text>
                            </View>

                        </View>

                        {thridcover()}
                    </View>
                </View>
                {/* ຮັບຜິດຊອບທາງແຜ່ງຕໍ່ ຜູ້ຂັບຂີ່/ Driver */}
                <View style={{
                    flexDirection: "column",
                    marginBottom: 2,
                    marginRight: 5,
                    marginLeft: 5,
                    padding: 5,
                    borderWidth: 0.5,
                }}>
                    {no.cover.search("I") >= 0 || no.cover.search("i") >= 0 ?
                        <View style={styles.box_f}>
                            <Text style={styles.fontHead}>
                                ຮັບຜິດຊອບທາງແຜ່ງຕໍ່ ຜູ້ຂັບຂີ່/ Driver
                            </Text>

                            <View style={{ ...styles.row_table }}>
                                <View style={styles.col} >
                                    <Text style={styles.fontHead}>ທາງເລືອກ/ Option </Text>
                                </View>
                                <View style={styles.col_1} >
                                    <Text style={styles.fontHead}>ເສຍຊີວິດ/ Death </Text>
                                </View>
                                <View style={styles.col_1} >
                                    <Text style={styles.fontHead}> ພິການຖາວອນ </Text>
                                    <Text style={styles.fontHead}> Total Permanent Disability </Text>
                                </View>
                                <View style={styles.col_1} >
                                    <Text style={styles.fontHead}>ຄ່າປິ່ນປົວສູງສຸດ/ຄົນ</Text>
                                    <Text style={styles.fontHead}>Medica expenses, Max per person</Text>
                                </View>
                            </View>
                            {drivercover_option.map((v, i) => {
                                return (
                                    <View key={i} style={{ ...styles.row_table }}>
                                        <View style={styles.col} >
                                            <Text style={styles.fontHead}>{v.optionname}</Text>
                                        </View>
                                        <View style={styles._col} >
                                            <Text style={styles.fontHead}>{format(v.died)} kip</Text>
                                        </View>
                                        <View style={styles._col} >
                                            <Text style={styles.fontHead}>{format(v.Permanent)} kip</Text>
                                        </View>
                                        <View style={styles._col} >
                                            <Text style={styles.fontHead}>{format(v.Medical)} kip</Text>
                                        </View>

                                    </View>
                                )
                            })}

                        </View>
                        :
                        null
                    }

                </View>
                {/* //ຄ່າທຳນຽມປະກັນໄພ */}
                <View style={styles.rowR}>

                    <View
                        style={{
                            border: '1px solid red',
                            borderRadius: 5,
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: 50
                        }}
                    >
                        <Text style={{ color: 'red' }}>
                            {no.policy_type === 'MS' ? 'MS' : 'ML'}
                        </Text>
                    </View>
                    <View style={styles.box_o2}>
                        <View style={{
                            flexDirection: "column",
                            marginBottom: 2,
                            marginRight: 5,
                            marginLeft: 5,
                            padding: 5,
                        }}>
                            <View style={styles.row_p}>
                                <View style={{ flex: 2, alignItems: 'flex-end' }} >
                                    <Text style={{ ...styles.fontHead }}>ຄ່າທຳນຽມປະກັນໄພ ບໍ່ທັນລວມອາກອນ/ Net Premium</Text>
                                </View>
                                <View style={styles.col3} >
                                    <Text style={styles.fontHead}>{format(no.premuim)}</Text>
                                </View>
                            </View>
                            <View style={styles.row_p}>
                                <View style={{ flex: 2, alignItems: 'flex-end' }} >
                                    <Text style={styles.fontHead}>ອາກອນມູນຄ່າເພີ່ມ/ VAT</Text>
                                </View>
                                <View style={styles.col3} >
                                    <Text style={styles.fontHead}>{format(no.vat)}</Text>
                                </View>
                            </View>
                            <View style={styles.row_p}>
                                <View style={{ flex: 2, alignItems: 'flex-end' }} >
                                    <Text style={styles.fontHead}>ຄ່າຂື້ນທະບຽນ/ Register</Text>
                                </View>
                                <View style={styles.col3} >
                                    <Text style={styles.fontHead}>{format(no.register)}</Text>
                                </View>
                            </View>
                            <View style={styles.row_p}>
                                <View style={{ flex: 2, alignItems: 'flex-end' }} >
                                    <Text style={styles.fontHead}>ລວມມູນຄ່າຕ້ອງຈ່າຍ/ Total premium to be paid</Text>
                                </View>
                                <View style={styles.col3} >
                                    <Text style={styles.fontHead}>{format(no.total_premuim)}</Text>
                                </View>
                            </View>

                        </View>
                    </View>
                    <View style={styles.box_o}>
                        <View style={styles.col}>
                            <Image src={qrpay} style={styles.qrCar} />
                            <Text style={styles.fontHead}>
                                ສະແກນເພື່ອຈ່າຍເງິນ
                            </Text>
                            <Image src={scanpaid} style={{ width: 40 }} />

                            {/* src={window.location.origin + "/smile.jpg"} */}
                        </View>
                    </View>

                </View>

                {/* ສະຖານະການຊຳລະ */}
                <View style={styles.rowR}>

                    <View style={styles.box_o2}>
                        <Text style={styles.fontHead}>ສະຖານະການຊຳລະ
                            {/* {JSON.stringify(no.emp_paid)} */}
                        </Text>
                    </View>
                    <View style={styles.box_o2}>
                        {no.emp_paid === 1 ?
                            <Image src={paid} style={{ width: 85 }} />
                            :
                            <Image src={notpaid} style={{ width: 160 }} />
                        }
                    </View>
                </View>
                <View style={styles.row_p}>
                    <View style={{ flex: 1, alignItems: 'center' }} >
                        <Text style={{ ...styles.fontHead, color: 'red', fontWeight: 'bold' }}>ເລີ່ມຄຸ້ມກັນ:: {moment(no.start).format("DD/MM/YYYY HH:mm:ss")} </Text>
                    </View>
                    <View style={{ flex: 1, alignItems: 'center' }} >
                        <Text style={{ ...styles.fontHead, color: 'red', fontWeight: 'bold' }}>ວັນສິ້ນສຸດ::  {moment(no.end).format("DD/MM/YYYY HH:mm:ss")} </Text>
                    </View>
                </View>

                {/* ສັນຍາສະບັບນີ້ */}

                <View style={{
                    flexDirection: "row",
                    // marginBottom: 2,
                    marginRight: 5,
                    marginLeft: 5,
                    padding: 5,

                }}>

                    <View style={{ flex: 1, alignItems: 'center' }} >
                        <Text style={styles.fontHead}>ຜູ້ອອກສັນຍາ</Text>
                        <Text style={styles.fontHead}>{no.userText}</Text>
                    </View>
                    <View style={{ flex: 1, alignItems: 'center' }} >
                        <Text style={styles.fontHead}> ສັນຍາສະບັບນີ້ ອອກເມື່ອວັນທີ: {moment(no.dateadd).format("DD/MM/YYYY HH:mm:ss")}</Text>
                        <Text style={styles.fontHead}>ບໍລິສັດ ຈົງຈີປະກັນໄພ ຈຳກັດ ຜູ້ດຽວ</Text>
                        {no.cancel === 1 ?
                            <Text style={{ fontSize: 10, color: 'red' }}>ສັນຍາສະບັບນີ້ ຖືກຍົກເລີກ  {no.cancel_date && moment(no.cancel_date).format("DD/MM/YYYY HH:mm:ss")} </Text> :
                            null   // <Image src={stam} style={{ width: 195 }} />
                        }
                    </View>
                </View>
                {/* ຂໍ້ຍົກເວັ້ນ */}
                <View style={{
                    flexDirection: "column",
                    // marginBottom: 2,
                    marginRight: 5,
                    marginLeft: 5,
                    // padding: 5,
                }}>
                    <Text style={{ fontSize: 8 }}>
                        ຂໍ້ຍົກເວັ້ນ/ Attention
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        1. ສັນຍາສະບັບນີ້ຈະບໍ່ຄຸ້ມກັນການເສຍຫາຍທີ່ເກີດຈາກຜູ້ຂັບຂີ່ທີ່ບໍ່ມີໃບຂັບຂີ່ຖືກຕ້ອງຕາມປະເພດລົດ ຫຼື ຂັບຂີ່ດ້ວຍຄວາມມຶນເມົາຈາກການດື່ມເຫຼົ້າ ຫຼື ຢາເສບຕິດ ຫຼື
                        ບໍ່ໄດ້ຮັບອະນຸຍາດຈາກຜູ້ໄດ້ຮັບການປະກັນໄພ/ This policy does not cover damage caused by driver without driving license or driving under the influence of alcohol or drug or
                        without consent of the insurer.
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        2. ສຳລັບລົດຈັກ, ຜູ້ຂັບຂີ່ ແລະ ຜູ້ຊ້ອນທ້າຍ ຕ້ອງໃສ່ໝວກກັນກະທົບ/ For the motorcycle, driver and passenger must wear a crash helmet to be indemnified under the “Driver and passenger” cover.
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        3. ຄວາມຮັບຜິດຊອບຕໍ່ບຸກຄົນທີສາມ ຈະບໍ່ຄຸ້ມກັນການເສຍຫາຍທາງດ້ານຮ່າງກາຍ ແລະ ວັດຖຸ, ຊັບສິນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ/ The third party  liability cover does not cover damages incurred to the insured and property of the insured.
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        4. ທຸກໆຄວາມເສຍຫາຍທີ່ເກີດຈາກການກໍ່ການຮ້າຍ ຈະບໍ່ໄດ້ຮັບການຄຸ້ມກັນ/ Any loss of damage caused by an act of terrorism is excluded.
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        5. ສັນຍາສະບັບນີ້ຈະບໍ່ຄຸ້ມກັນຄວາມເສຍຫາຍຈາກ ການຍັກຍ້ອກສໍ້ໂກງພາຍໄຕ້ສັນຍາເຊົ່າ, ຊື້-ຂາຍຜ່ອນ, ມັດຈຳ ດ້ວຍບຸກຄົນທີ່ມີສ່ວນພົວພັນໃນສັນຍາ ດັ່ງກ່າວ/ This policy does not cover loss or damage cause by  embezzlement  under cause by an act of terrorism is excluded.
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        6. ກໍລະນີເກີດອຸປະຕິເຫດ, ຜູ້ໄດ້ຮັບການປະກັນໄພຕ້ອງແຈ້ງໃຫ້ບໍລິສັດ ຈົງຈີ ປະກັນໄພ (ZJI) ຮັບຮູ້ທັນທີ ໂທ: 020 57999922/ 020 57999933/
                        In case of accident the insured must notify immediately Zhongji Insurance Company (ZJI) Call:  020 57999922/ 020 57999933.
                    </Text>
                    <Text style={styles.fontHeadSmall}>
                        7. ZJI ຈະບໍ່ຮັບຜິດຊອບທຸກໆການທົດແທນຄ່າເສຍຫາຍຕໍ່ຄູ່ກໍລະນີ ໂດຍທີ່ບໍ່ໄດ້ມີການຕົກລົງຈາກ ZJI/ ZJI will not be liable to any agreement between  the insured and the third parties without the consent of ZJI.
                    </Text>
                    <Text style={{ ...styles.fontHeadSmall }}>
                        8. ສັນຍາສະບັບນີ້ຈະມີຜົນນໍາໃຊ້ກໍ່ຕໍ່ເມືອ ZJI ໄດ້ຮັບຄ່າທໍານຽມປະກັນໄພຄົບຖ້ວນ/ The insurance shall be effective upon the receipt of full premium payment.
                    </Text>
                </View>
                <Image src={img} style={styles.qr} />
                <Text style={styles.info}>ຜູ້ສ້າງ {JSON.stringify(user)} ເມື່ອວັນທີ {moment(Date.now()).format("DD/MM/YYYY HH:mm:ss")} </Text>
                {/* <Text>{img}</Text> */}
            </Page>
        </Document>
    );
}


